import React,{ useState,useEffect} from 'react'
import DataTable from '../Components/Molecules/Table/DataTable'

import _ from "lodash";
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import RadioButton from "../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
import styles from "../../src/Pages/Dashboard/Dashboard.module.scss";
//import styles from "./Dashboard.module.scss";
import HBar from "../Components/Bars/Bars";
import {add_service_type_configuration,edit_service_type_configuration,branch_list,get_master_data,users_list,get_configuration_list} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";
import moment from "moment";
import { FaArrowLeft } from 'react-icons/fa';
export default function ServiceConfigurationList() {

const [branchList, setBranchList] = useState([])
const  [selectedRow, setSelectedRow] = useState(null)
const [OpenForm,setOpenForm] = useState(0)
const userData = useSelector((state) => state.auth.user);
const [filterData,setFilterData] = useState({"role_id":[]})
const [filterTenant,setfilterTenant] = useState(null)

const [reloadList, setreloadList] =useState({})
useEffect(()=>{
  setreloadList({...filterData})
},[filterTenant])
let columnDefs = [
    { headerName: "ID", field: "index" ,width: 80},
    { headerName: "Service Name", field: "service_details.name", minWidth:150},
    { headerName: "Name", field: "user_details.name", minWidth:150},
    { headerName: "Email", field: "user_details.email",minWidth:150 },
    { headerName: "Phone", field: "user_details.mobile_no",minWidth:150 },
    //{ headerName: "Tenant", field: "tenant_details.name",minWidth:150 },
    //{ headerName: "Actions", field: "actions",maxWidth:10000 },
  ];

  if(_.get(userData,"role_id",null) ==1){
    columnDefs.push({ headerName: "Tenant", field: "tenant_details.name",minWidth:150 })
    
  }
  if(_.get(userData,"role_id",null) ==1 || _.get(userData,"role_id",null) ==2 ){
    columnDefs.push({ headerName: "Actions", field: "actions",maxWidth:10000 })
  }

  const [selectedTenant, setSelectedTenant ] = useState(()=>{
    if(_.get(userData, "tenant_details",null) !=null){
        return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
     
      
    }else{
      return null
    }
      
  })
  const [serviceTypes,setServiceTypes] = useState([])
  const [selectedServiceType, setSelectedServiceType ]  = useState(null)
  
  const [usersList,setUsersList] = useState([])
  const [selectedUser, setSelectedUser ]  = useState(null)
  const [isSpinner, setIsSpinner] = useState(false);
  const handleSubmit = (values) => {
    setIsSpinner(true);
    values["service_type_id"] = _.get(selectedServiceType,"id");
    values["tenant_id"] = _.get(selectedTenant,"id");
    values["user_id"] = _.get(selectedUser,"id");
    let url = add_service_type_configuration
    if(_.get(selectedRow,"id", false)){
      values["configuration_id"] =  _.get(selectedRow,"id")
      url = edit_service_type_configuration
    }
     postMethod(url,values).then((res)=>{
      showToast("success",_.get(res, "message","Something went wrong!"))
      setOpenForm(0)
      setIsSpinner(false);
      setSelectedRow(null)
      setSelectedUser(null)
      setSelectedServiceType(null)

    }).catch ((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);
      setSelectedRow(null)
      setSelectedUser(null)
      setSelectedServiceType(null)

    })
  };

  
  const get_users = (text)=>{

    //users_list
    let postData = {
      "search_string": text,
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "role_id": [3]
    }
    if(_.get(userData, "role_id") ==1){
      if(_.get(selectedTenant, "id")){
        postData["tenant_id"] = [_.get(selectedTenant, "id")]
      }
    }else{
      postData["tenant_id"] = [_.get(userData, "tenant_id")]
           
    }
    setSelectedUser(null)
    setUsersList([])
    postMethod(users_list,postData).then((res)=>{
      if(_.get(res, "list.length") >0){
        let list = res["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        setUsersList(list);
      }
      
    })


  }
              
  const getBranchList = ()=>{
    let postData = {
      "search_string": "",
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "status_ids": []
    }
    
    postMethod(branch_list,postData).then((res)=>{
      if(_.get(res, "list.length") >0){
        let list = res["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        let fitem = list.find((item)=>item.id=1);
        if(fitem){
          
          setFilterData((data)=>{
            setfilterTenant(fitem)
            return {...data, "teanat_id":_.get(fitem,"id")}
          });
          
        }
       
        setBranchList(list);
      }
      
    })

  }
  useEffect(()=>{
    getBranchList();
    if(OpenForm ==1 ){
      
      getMasterData();
      get_users()
    }
    getMasterData(); 
  },[OpenForm])
  useEffect(()=>{
    if(OpenForm ==1 ){
     
      get_users()
      
    }
    
  },[selectedTenant])
  
  
  const getMasterData = ()=>{
    let postData = {"categories":["md_service_types"]};
    //values["tenant_id"] = _.get(selectedTenant,"id");
     postMethod(get_master_data,postData).then((res)=>{
        setServiceTypes( _.get(res,"result.md_service_types",[]).map((item)=>{ item["label"] =  item["name"];return item}))
        })
  }


  
  
 let formData = {
  tenant_id: Yup.string(),
  user_id: Yup.string(),
  service_type_id:Yup.string()
   
}
let initialValues ={
  tenant_id:_.get(selectedTenant,"id")
  
}
if(_.get(userData,"tenant_id") ==1){
  formData["tenant_id"] = Yup.number()
  .required("Branch is required")
  
}
let formik = useFormik({
    initialValues:initialValues,
    validationSchema: Yup.object(formData),
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: true,
  });

  
  const getDetails = (row)=>{
        
  setSelectedUser( _.get(row,"user_details",null))
  setSelectedServiceType( _.get(row,"service_details",null))
    setSelectedRow(row)
    formik.setFieldValue("tenant_id", _.get(row,"tenant_id",""))
    formik.setFieldValue("user_id", _.get(row,"user_id",""))
    formik.setFieldValue("service_type_id", _.get(row,"service_type_id",""))
    
    if(_.get(row,"tenant_details",false)){
      setSelectedTenant(row["tenant_details"])
      formik.setFieldValue("tenant_id", _.get(row,"tenant_details.id",""))
    }
    
   
    setOpenForm(1)

  }

  useEffect(()=>{
    if(OpenForm !=1){
      formik.resetForm();
      setSelectedRow(null)
    }
   
  },[OpenForm])

  
  

  return (
    <div>
      <div className="row" >

      <div className="d-flex align-items-center mb-3">
      
      {OpenForm>0 && <div style={{"cursor":"pointer"}} onClick={()=>{setOpenForm(0)}}  className="mr-1000 cursor-pointer arrow"><FaArrowLeft size={20}   /></div>} {/* Back arrow icon */}
    
     <h3> 
      
      {
        OpenForm==0?"Service Configuration List":OpenForm!=0?_.get(selectedRow,"id")?"Update":"Add":""
      }
      
    </h3>
    </div>


      
         <div className="col-md-2 mb-0">
              
                {OpenForm === 0 && (
                  _.get(userData, "role_id") === 1 && _.get(branchList, "length") > 0 && (
                    <FormDropdown
                      id="filter_tenant_id"
                      name="filter_tenant_id"
                      label="Tenant"
                      options={branchList}
                      onChange={(selected) => {
                        setFilterData((data) => {
                          setfilterTenant(data);
                          return { ...data, "teanat_id": _.get(selected, "id") };
                        });
                      }}
                      value={_.get(selectedTenant, "id")}
                      error={formik.touched.service_type_id && formik.errors.service_type_id}
                    />
                  )
                )}
                </div>
              </div>                
                   
        <div className={'mt-3'}>
           {OpenForm ==0 && <DataTable loaded_from="SERVICE_CONFIGURATION_LIST" columnDefs={columnDefs} apiUrl={get_configuration_list} setFilterData={setFilterData} filterData={filterData} setOpenForm={(v)=>{setSelectedRow(null); setOpenForm(1)}} editRow={(item)=>{getDetails(item)}} showCreateBtn={true} reloadList={reloadList} />}
          
          
          { OpenForm ==1 && <>
            <Card className="">
            <div className="pt-1">
            {/* First Row */}
              <div className="row">
              <div className="col-md-4 mb-2">
                 <FormDropdown
                  id="service_type_id"
                  name="service_type_id"
                  label="Service Type"
                  options={serviceTypes}
                  onChange={(selected) => {
                    
                    setSelectedServiceType(selected);
                    formik.setFieldValue("service_type_id", selected?.label);
                  }}
                  value={formik.values.service_type_id}
                  error={formik.touched.service_type_id && formik.errors.service_type_id}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.service_type_id && <ErrorLabel name="service_type_id" formik={formik} message={formik.errors.service_type_id} />}
              </div>                
             
                <div className="col-md-4 mb-2">
                  <FormDropdown
                    id="tenant_id"
                    name="tenant_id"
                    label="Select Branch"
                    options={branchList}
                    onChange={(selected) => {
                      setSelectedTenant({...selected})
                      if (selected?.id) {
                        
                        formik.setFieldValue("tenant_id", selected?.id);
                      }
                    }}
                    value={formik?.values?.tenant_id}
                    error={formik.touched.tenant_id && formik.errors.tenant_id}
                    isImportant={_.get(userData,"role_id") ==1}
                    onBlur={formik.handleBlur}
                    disabled={_.get(userData,"role_id") !=1}
                  />
                  {formik.touched.tenant_id && <ErrorLabel name="tenant_id" formik={formik} message={formik.errors.tenant_id} />}
                </div>
               
              
                <div className="col-md-4 mb-2">
                  <FormDropdown
                    id="user_id"
                    name="user_id"
                    label="Select User"
                    options={usersList}
                    onChange={(selected) => {
                      setSelectedUser({...selected})                      
                      if (selected?.id) {
                        
                        formik.setFieldValue("user_id", selected?.id);
                      }
                    }}
                    value={formik?.values?.user_id}
                    error={formik.touched.user_id && formik.errors.user_id}
                    isImportant={true}
                    onBlur={formik.handleBlur}
                    disabled={false}
                  />
                  {formik.touched.user_id && <ErrorLabel name="user_id" formik={formik} message={formik.errors.user_id} />}
                </div>
                
              </div>
              

              <div className="row justify-content-end w-100">
            <div className="d-flex justify-content-end" style={{ gap: "16px" }}>
              <CancelButton label="Cancel" onClick={()=>setOpenForm(0)} className="btn btn-secondary" />
              <PrimaryButton
                type="submit"
                onClick={formik.handleSubmit}
                spinner={isSpinner}
                label={_.get(selectedRow,"id")?"Update":"Submit"}
                disabled={!(formik.dirty && formik.isValid)}
              />
            </div>
          </div>
            </div>
          
          </Card>
          
          </> }
        </div>
    </div>
  )
}
